<template>
  <md-button
    :href="anchor"
    :type="buttonType"
    :md-ripple="ripple"
    :class="[
      getColor,
      getTextColor,
      getMaterialClass,
      getMaterialType,
      getBorderColor,
      getBorderRadius,
    ]"
    :disabled="disabled"
    @click.prevent="$emit('button')"
    :data-cy="dataCy"
    :to="to"
  >
    <div :class="[getClassContent]">
      <md-icon
        class="icon-without-text"
        :md-src="svgIcon"
        :class="[getIconColor, `md-size-${iconSize}`]"
        v-if="svgIcon && iconWithoutText && !text"
      />
      <md-icon
        class="icon-without-text"
        :class="[getIconColor]"
        v-if="!svgIcon && iconWithoutText && !text"
        >{{ iconWithoutText }}</md-icon
      >
      <md-icon
        class="icon-left-text mr-1"
        :md-src="svgIcon"
        :class="[getIconColor, `md-size-${iconSize}`]"
        v-if="svgIcon && iconLeftText"
      />
      <md-icon
        class="icon-left-text mr-1"
        :class="[getIconColor]"
        v-if="!svgIcon && iconLeftText"
        >{{ iconLeftText }}</md-icon
      >
      <div v-if="!svgIcon && iconTopText" class="row">
        <md-icon
          class="col col-12 icon-top button-pad"
          :class="[getIconColor, `md-size-${iconSize}`]"
          >{{ iconTopText }}</md-icon
        >
        <span class="col col-12 button-pad icon-top-text">{{ text }}</span>
      </div>
      <span :class="[getTextSize]" 
      v-if="text && !iconWithoutText && !iconTopText">
        {{ text }}
      </span>
      <md-icon
        class="icon-right-text ml-1"
        :md-src="svgIcon"
        :class="[getIconColor, `md-size-${iconSize}`]"
        v-if="svgIcon && iconRightText"
      />
      <md-icon
        class="icon-right-text ml-1"
        :class="[getIconColor]"
        v-if="!svgIcon && iconRightText"
        >{{ iconRightText }}</md-icon
      >
    </div>
  </md-button>
</template>

<script>
export default {
  name: "SButtonMaterial",
  props: [
    "text",
    "size",
    "color",
    "disabled",
    "dataCy",
    "mousedownPrevent",
    "anchor",
    "buttonType",
    "ripple",
    "materialClass",
    "textColor",
    "iconColor",
    "iconGravity",
    "iconLeftText",
    "iconRightText",
    "iconTopText",
    "iconWithoutText",
    "to",
    "materialType",
    "borderColor",
    "borderRadius",
    "svgIcon",
    "iconSize",
  ],
  computed: {
    getClassContent() {
      if (!this.iconWithoutText) return "button-content";
      return "";
    },
    getColor() {
      if (this.disabled && this.color !== "transparent") return "disabled";
      switch (this.color) {
        case "primary":
          return "material-primary";
        case "secondary":
          return "material-secondary";
        case "tertiary":
          return "material-tertiary";
        case "danger":
          return "material-danger";
        case "warning":
          return "material-warning";
        case "offer":
          return "material-offer";
        case "info":
          return "material-info";
        case "grey":
          return "material-grey";
        case "darker-grey":
          return "material-darker-grey";
        case "transparent":
          return "material-transparent";
        default:
          return "";
      }
    },
    getBorderColor() {
      if (this.disabled) return "border-disabled";
      switch (this.borderColor) {
        case "primary":
          return "border-primary";
        case "secondary":
          return "border-secondary";
        case "tertiary":
          return "border-tertiary";
        case "danger":
          return "border-danger";
        case "warning":
          return "border-warning";
        case "offer":
          return "border-offer";
        case "info":
          return "border-info";
        case "noBorder":
          return "border-no-border";
        default:
          return "";
      }
    },
    getSize() {
      switch (this.size) {
        case "default":
          return "large-size";
        case "large":
          return "large-size";
        case "medium":
          return "medium-size";
        case "small":
          return "small-size";
        default:
          return "";
      }
    },
    getMaterialClass() {
      switch (this.materialClass) {
        case "raised":
          return "md-raised";
        case "dense":
          return "md-dense";
        case "block":
          return "md-block";
        case "wd":
          return "md-wd";
        case "md-pr":
          return "md-primary";
        default:
          return "";
      }
    },
    getTextColor() {
      switch (this.textColor) {
        case "disabled":
          return "text-color-disabled";
        case "white":
          return "text-color-white";
        case "primary":
          return "text-color-primary";
        case "secondary":
          return "text-color-secondary";
        case "tertiary":
          return "text-color-tertiary";
        case "danger":
          return "text-color-danger";
        case "warning":
          return "text-color-warning";
        case "offer":
          return "text-color-offer";
        case "grey":
          return "text-color-grey ";
        case "darker-grey":
          return "text-color-darker-grey ";
        default:
          return "";
      }
    },
    getTextSize() {
      if(this.text === "Currently unavailable")
        return "text-size";
      return "";
    },
    getIconColor() {
      switch (this.iconColor) {
        case "disabled":
          return "icon-color-disabled";
        case "white":
          return "icon-color-white";
        case "primary":
          return "icon-color-primary";
        case "secondary":
          return "icon-color-secondary";
        case "tertiary":
          return "icon-color-tertiary";
        case "danger":
          return "icon-color-danger";
        case "warning":
          return "icon-color-warning";
        case "offer":
          return "icon-color-offer";
        case "grey":
          return "icon-color-grey";
        case "darker-grey":
          return "icon-color-darker-grey";
        default:
          return "";
      }
    },
    getMaterialType() {
      switch (this.materialType) {
        case "primary":
          return "md-primary";
        case "accent":
          return "md-accent";
        default:
          return "";
      }
    },
    getBorderRadius() {
      switch (this.borderRadius) {
        case "small":
          return "border-radius-small";
        case "medium":
          return "border-radius-medium";
        case "big":
          return "border-radius-big";
        case "extra":
          return "border-radius-extra";
        default:
          return "border-radius-default";
      }
    },
  },
};
</script>

<style scoped>
.md-button {
  margin: 0;
}

a {
  text-align: center;
  line-height: 40px !important;
}
.md-icon.md-size-1x {
  height: 23px;
  width: 33px;
  font-size: 27px !important;
}
.md-icon.md-size-custom {
  width: 30px;
  height: 28px;
}
.button-pad {
  padding-left: unset;
  padding-right: unset;
}
.icon-top-text {
  font-size: 13px;
}
.icon-top {
  font-size: 26px !important;
}
</style>

<style lang="scss" scoped>
.text-color-disabled,
.icon-color-disabled {
  color: $grey !important;
}
.text-color-white,
.icon-color-white {
  color: $white !important;
}
.text-color-primary,
.icon-color-primary {
  color: $primary !important;
}
.text-color-secondary,
.icon-color-secondary {
  color: $secondary !important;
}
.text-color-tertiary,
.icon-color-tertiary {
  color: $tertiary !important;
}
.text-color-danger,
.icon-color-danger {
  color: $danger !important;
}
.text-color-warning,
.icon-color-warning {
  color: $warning !important;
}
.text-color-offer,
.icon-color-offer {
  color: $offer !important;
}
.text-color-grey,
.icon-color-grey {
  color: $grey !important;
}
.text-color-darker-grey,
.icon-color-darker-grey {
  color: $dark !important;
}
.material-primary {
  background-color: $primary;
}
.text-size {
  white-space: normal;
}
.material-secondary {
  background-color: $secondary;
}
.material-tertiary,
.material-info {
  background-color: $tertiary;
}
.material-danger {
  background-color: $danger;
}
.material-warning {
  background-color: $warning;
}
.material-success {
  background-color: $offer;
}
.material-offer {
  background-color: $offer;
}
.material-grey {
  background-color: $grey;
}
.material-darker-grey {
  background-color: $dark;
}
.material-transparent {
  background-color: transparent;
}
.border-disabled {
  border: 1px solid $grey;
}
.border-primary {
  border: 1px solid $primary !important;
}
.border-secondary {
  border: 1px solid $secondary;
}
.border-tertiary {
  border: 1px solid $tertiary;
}
.border-danger {
  border: 1px solid $danger;
}
.border-warning {
  border: 1px solid $warning;
}
.border-success,
.border-offer {
  border: 1px solid $offer;
}
.border-no-border {
  border: 0 !important;
}
.button-content {
  align-items: center;
  display: flex;
  letter-spacing: 0.1rem;
}
.icon-left-text {
  margin-right: 0.2rem;
}
.disabled {
  background-color: $dark;
}

.border-radius-default {
  border-radius: 0.25em;
}
.border-radius-small {
  border-radius: 0.375em;
}
.border-radius-medium {
  border-radius: 0.5em;
}
.border-radius-big {
  border-radius: 0.75em;
}
.border-radius-extra {
  border-radius: 1em;
}
span {
  white-space: normal;
}


@media screen and (max-width: 425px) {
  span {
    font-size: smaller;
  }
}
</style>
